<template>
  <div class="px-1">
    <el-form-item>
      <span class="form-label">หัวเรื่อง</span>
      <el-input
        v-model="form.subject"
        type="textarea"
        :autosize="{ minRows: 4, maxRows: 6 }"
      >
      </el-input>
    </el-form-item>

    <el-form-item>
      <span class="form-label">ป้ายกำกับ</span>
      <el-select
        v-model="form.tags"
        multiple
        filterable
        allow-create
        default-first-option
        reserve-keyword
        :loading="loading"
      >
        <el-option
          v-for="(item, index) in tagsList"
          :key="index"
          :label="item?.name"
          :value="item?.name"
        >
        </el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
export default {
  props: {
    emitData: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        subject: "",
        tags: [],
      },
      tagsList: [],
      list: [],
      loading: false,
    };
  },
  watch: {
    async emitData() {
      this.$emit("resultData", this.form);
    },
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      await this.$store.dispatch("ui/setIsFullScreenLoading", true);
      const { results } = await this.$store.dispatch(
        "healthRecord/getListTags"
      );
      this.tagsList = results;

      await this.$store.dispatch("ui/setIsFullScreenLoading", false);
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.tagsList = this.list.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.tagsList = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-select {
  display: flex;
}

.el-tag.el-tag--info {
  background-color: #005972;
  border-color: #e9e9eb;
  color: #ffffff;
}
</style>